import {GET_FillExamType} from '../constants/ActionTypes'

const INIT_STATE = {
    ExamType: null,
    loading: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_FillExamType:
                return {
                    ExamType: action.body,
                    //Message1:action.msg
                  
                }
        default:
            return state;
    }
}